import { LogtoConfig } from "@logto/react";
// Logto configuration
export const logtoConfig: LogtoConfig = {
  endpoint: import.meta.env.VITE_LOGTO_ENDPOINT || "https://aowwt7.logto.app/",
  appId: import.meta.env.VITE_LOGTO_APP_ID || "pz72o8s9ygr20lkg3uu2f",
  scopes: ["openid", "profile", "email"],
};
